import {PutBank} from 'domain/usecases';
import {makeBFFApiUrl} from 'main/factories/http';

import {RemoteRefundPutBank} from 'data/usecases';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {RefundFlowEndPoints} from '../../../endpoints';

export const makeRefundPutBank = (): PutBank =>
	new RemoteRefundPutBank(
		makeBFFApiUrl(RefundFlowEndPoints.beneficiaryBankData),
		makeAuthorizeHttpClientDecorator(),
	);
